import $ from "./jq";


(function(){
    $(".j-vs-btn").on("click",function(){
        $(".j-nav-wrapper").removeClass("hide");
    })
    $(".j-close-layout").on("click",function(){
        $(".j-nav-wrapper").addClass("hide");
    })
    $(".j-nav-wrapper").on("click",function(){
        $(this).addClass("hide");
    })
    $(".j-returnBtn").on("click",function(){
        window.history.back()
    })
})()